import React from "react";
import { IoMdArrowDropdown } from "react-icons/io";

export default function SelectInput({
  label,
  placeholder,
  options,
  value,
  onChange,
  error,
}) {
  const hasValue = value && value !== "";

  const borderColor = error ? "border-red-500" : "border-gray-300";
  const textColor = error
    ? "text-red-500"
    : hasValue
    ? "text-default"
    : "text-gray-400";
  const iconColor = error
    ? "text-red-500"
    : hasValue
    ? "text-default"
    : "text-gray-300";

  return (
    <div className="flex flex-1 relative flex-col gap-1 w-full">
      {label && (
        <label className={`text-[15px] text-start text-default`}>{label}</label>
      )}

      <div
        className={`relative flex items-center border ${borderColor} rounded-xl px-4 py-3 bg-white focus-within:border-gray-600 transition`}
      >
        <select
          className={`w-full appearance-none outline-none bg-transparent text-[15px] ${textColor}`}
          value={value}
          onChange={onChange}
        >
          <option value="" disabled hidden>
            {placeholder || "Selecione"}
          </option>
          {options?.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        <IoMdArrowDropdown
          className={`absolute right-4 text-lg ${iconColor}`}
        />
      </div>

      {error && (
        <span className="text-red-500 absolute -bottom-6 left-0 text-[13px]">
          {error}
        </span>
      )}
    </div>
  );
}
